export enum PaymentMethodKind {
    Unknown = 'unknown',
    Card = 'card',
    Sbp = 'sbp',
    Installment = 'installment',
    Wallet = 'wallet',
    Invoice = 'invoice',
    Other = 'other',
    Cash = 'cash'
}
